(function handleScrollTop() {
  const btnScrollTop = document.querySelector('.btn-scroll-top');

  if (!btnScrollTop) return;

  btnScrollTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });

  // Use requestAnimationFrame for smooth performance
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const scrollPosition = window.pageYOffset;
        
        if (scrollPosition > 300) {
          btnScrollTop.classList.add('show');
        } else {
          btnScrollTop.classList.remove('show');
        }
        
        ticking = false;
      });
      
      ticking = true;
    }
  });
})();